import { jsx as _jsx } from "react/jsx-runtime";
import { Route } from 'react-router-dom';
export const ComponentRoute = ({ route, newPath }) => {
    const Component = route.component;
    if (Component === undefined) {
        return null;
    }
    if (route.exact) {
        return (_jsx(Route, Object.assign({ path: newPath, exact: true }, { children: _jsx(Component, { data: route.data }, void 0) }), void 0));
    }
    return _jsx(Component, { data: route.data }, void 0);
};
//# sourceMappingURL=ComponentRoute.js.map